import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ListItem from '../../elements/DEPRECATED_ListItem';
import Scrollable from '../../elements/Scrollable';
import ShareContent from '../../elements/ShareContent/ShareContent';
import SlideDownContent from '../../elements/SlideDownContent/SlideDownContent';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import LoadNews from '../../loaders/LoadNews';
import SandboxedContent from '../../SandboxedContent/SandboxedContent';
import HasData from '../../validate/HasData';
import WaitWhileBusy from '../../WaitWhileBusy';
import location from '../Meetings/Location/Location';
import Screen from '../Screen';
import NewsTargetButton from './NewsTargetButton';
import ReadMoreButton from './ReadMoreButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import styles from './EventNewsDetails.module.scss';

export class EventNewsDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contentHeight: window.innerHeight - 124,
            showShareOptions: false,
        };
    }
    componentDidMount() {
        this.props.notifications.forEach((notif) => {
            app.api.notifications.markRead(notif.id);
        });
    }
    shouldComponentUpdate(props, state) {
        return !_.isEqual(props, this.props) || !_.isEqual(state, this.state);
    }
    render() {
        let { event, i18n, article } = this.props,
            catId;

        let iconImg = 'img/news-icon.png';
        if (article.icon) {
            iconImg = (article.icon.match('^http') ? '' : 'img/') + article.icon;
        }

        let header = (
                <div>
                    <TopBarEvent event={event} />
                    <hr />

                    <ListItem style={{ backgroundColor: 'white' }} tagName="div" icon={iconImg}>
                        <p
                            className="text main"
                            style={{
                                fontSize: '150%',
                                padding: '5px 0',
                                color: event.settings.primary_color,
                            }}>
                            {article.title}
                        </p>
                    </ListItem>
                </div>
            ),
            footer = null;

        let shareButton;
        if (article.shareable && article.read_more_url) {
            shareButton = (
                <button className={styles.share} onClick={this.handleShareButtonClicked.bind(this)}>
                    <FontAwesomeIcon icon={faShareAlt} />
                </button>
            );
        }

        return (
            <Screen header={header} footer={footer}>
                <Scrollable>
                    <div className="content">
                        <small>{moment(article.date_published).format('llll')}</small>
                    </div>
                    <SandboxedContent content={article.description} fitHeightToContents="fitHeightToContents" />

                    <div className="marginTop marginBottom">
                        <ReadMoreButton article={article} />
                        <NewsTargetButton eventId={event.id} article={article} />
                    </div>
                    <div className="content">
                        {shareButton}
                        {article.disclaimer}
                        <SlideDownContent
                            isVisible={this.state.showShareOptions}
                            style={{
                                clear: 'both',
                                marginTop: '3ex',
                                borderRadius: '8px',
                                backgroundColor: 'white',
                            }}>
                            <ShareContent url={article.read_more_url || location.href} message={article.title} />
                        </SlideDownContent>
                    </div>
                </Scrollable>
            </Screen>
        );
    }
    handleShareButtonClicked() {
        if (navigator?.share) {
            let { article } = this.props;
            navigator.share({
                url: article.read_more_url || location.href,
                title: article.title,
            });
        } else {
            this.setState({ showShareOptions: !this.state.showShareOptions });
        }
    }
    handleHeaderMeasure(dims) {
        this.setState({
            contentHeight: window.innerHeight - dims.height - 44,
        });
    }
}

export const ConnectedEventNewsDetails = connect((state, props) => {
    return {
        eventId: props.eventId,
        event: state.events[props.eventId].event,
        article: state.events[props.eventId].news.indexed[props.articleId],
        i18n: state.i18n.translations,
        notifications: _(state.events[props.eventId].notifications.eventMessage)
            .filter((notif) => _.get(notif, 'content.data.newsId') == props.articleId)
            .reject((notif) => notif.read)
            .value(),
    };
})(EventNewsDetails);

export default (props) => {
    const { eventId, articleId } = useParams();
    return (
        <LoadNews eventId={eventId} articleId={articleId}>
            <WaitWhileBusy>
                <HasData path={`events[${eventId}].news.indexed[${articleId}]`} errorMessage={`Article not found: ${articleId}`}>
                    <ConnectedEventNewsDetails {...props.match.params} />
                </HasData>
            </WaitWhileBusy>
        </LoadNews>
    );
};
